<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="6">
          <b-col md="6 mt-3 float-right">
            <b-button
              variant="primary"
              class="mb-2 float-right btn-custom"
              @click="showModal('Add')"
              ><font-awesome-icon icon="plus"
            /></b-button>
          </b-col>
        </b-col>
      </b-row>
      <paginated-table
        ref="dataTable"
        :can-edit="false"
        :can-delete="false"
        :can-approve="false"
        :can-reject="false"
        :can-show="false"
        :can-edit-modal="true"
        :can-paid="false"
        v-on:editData="doEdit"
        :data-url="apiUrl"
        :data-key="dataKey"
        :data-columns="columns"
      >
      </paginated-table>
    </b-card>
    <b-modal ref="my-modal" centered hide-footer :title="type + ' Worksheet Type'">
      <form v-on:submit.prevent="doSubmit">
        <label for="" class="mt-2 labels">Name *</label>
        <b-form-input
          type="text"
          class="mb-3"
          v-model="model.name"
          placeholder="Enter Name"
          name="name"
          v-bind:class="errors.has('name') ? 'is-invalid' : ''"
          v-validate="'required'"
        ></b-form-input>
        <label for="" class="mt-2 labels">Note *</label>
        <input
          type="text"
          v-model="model.note"
          class="mb-3 form-control"
          placeholder="Enter Note"
          name="quota"
          v-bind:class="errors.has('quota') ? 'is-invalid' : ''"
          v-validate="'required'"
        />
      

        <b-button class="mt-3" variant="secondary" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
        <b-button class="mt-3 float-right" variant="primary" type="submit"
          ><font-awesome-icon icon="save"></font-awesome-icon
          >{{ this.model.uuid !== null ? ' Update' : ' Submit' }}
        </b-button>
      </form>
    </b-modal>
        <edit-worksheet-type-modal ref="editWorksheetType" v-on:getWorksheetType="getWorksheetType"></edit-worksheet-type-modal>
  </div>
</template>

<script>
import PaginatedTable from '../../../components/PaginatedTable.vue';
import EditWorksheetTypeModal from './EditWorksheetTypeModal.vue';
export default {
  name: 'worksheet-type',
  components: { PaginatedTable, EditWorksheetTypeModal },
  data() {
    return {
      dataKey: 'worksheet_type',
      isLoading: false,
      apiUrl: window.AppConfig.apiUrl + 'worksheet-type',
      type: null,
      model: {
        name: null,
        uuid: null,
        note: null,
      },
      columns: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'note',
          label: 'Note',
          sortable: true,
        },

        {
          key: 'actionTypes',
          label: '',
        },
      ],
    };
  },
  mounted() {
    this.getWorksheetType();
  },
  methods: {
    getWorksheetType() {
      this.isLoading = true;
      this.$refs.dataTable.getDataTable();
    },
    doSubmit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.model.uuid !== null) {
            this.$http
              .patch(this.apiUrl + '/' + this.model.uuid, {
                name: this.model.name,
                note: this.model.note,
              })
              // eslint-disable-next-line no-unused-vars
              .then((response) => {
                this.$store.dispatch('notification/success', 'Worksheet type has been updated.');
                this.$refs.dataTable.doFilter();
                this.hideModal();
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          } else {
            this.$http
              .post(this.apiUrl, {
                name: this.model.name,
                note: this.model.note,
              })
              // eslint-disable-next-line no-unused-vars
              .then((response) => {
                this.$store.dispatch('notification/success', 'Worksheet type has been added.');
                this.$refs.dataTable.doFilter();
                this.hideModal();
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          }
        }
      });
    },
    showModal(type) {
      this.model.name = null;
      this.model.note = null;
      this.$validator.reset();
      this.type = type;
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    doEdit(row) {
      this.$refs.editWorksheetType.showModal(row);
    },
    doShowModal(row) {
      this.$refs.editWorksheetType.showModal(row);
    },
  },
};
</script>
